<template>
    <div class="control">
        <label v-for="role in allRoles" :for="`role-${role}`" :key="role" class="radio">
            <input type="radio" :id="`role-${role}`" :value="role" :checked="selectedRole === role" @change="$emit('update:selectedRole', role)" />
            {{ getRoleName(role) }}
        </label>
    </div>
</template>

<script>
import { RegistrationRole } from '@/utils/registration'

export default {
    name: 'RegisterFormPartRole',
    props: {
        labelChild: String,
        labelAdult: String,
        selectedRole: String
,    },
    computed: {
        allRoles() {
            return Object.values(RegistrationRole);
        },
    },
    emits: [
        'update:selectedRole',
    ],
    methods: {
        getRoleName(role) {
            switch (role) {
                case RegistrationRole.Child:
                    return this.labelChild;
                case RegistrationRole.Adult:
                    return this.labelAdult;
                default:
                    return '';
            }
        },
    }
}
</script>
